import { render } from "./AboutView.vue?vue&type=template&id=2112766a&scoped=true&lang=pug"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=2112766a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2112766a"]])

export default __exports__